





















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import { DxPopup } from 'devextreme-vue/popup';
import Card from '@/components/default/Card.vue';
import { DxTextBox } from 'devextreme-vue';
import { DxTreeList, DxEditing, DxRowDragging, DxColumnFixing, DxStateStoring } from 'devextreme-vue/tree-list';
import { InvoiceBlock, InvoiceLine, IInvoiceLine, InvoiceDto } from '@/data/web-api-client';
import notificationService from '@/services/notificationService';
import AddArticleDialog from '@/modules/quotations/components/dialogs/AddArticleDialog.vue';

@Component({
    components: {
        DxPopup,
        DxTextBox,
        Card,
        DxTreeList,
        DxEditing,
        DxRowDragging,
        DxColumnFixing,
        DxStateStoring,
        AddArticleDialog,
    },
})
export default class InvoiceBlockCard extends Vue {
    @Prop({required: true})
    private invoice!: InvoiceDto;

    @Prop({required: true})
    value!: InvoiceBlock;

    @Prop({required: false, default: false})
    private hide?: boolean;

    @Prop({required: false, default: false})
    disabled?: boolean;

    @Prop({ required: false, default: false })
    editDisabled?: boolean;

    private parentRecordId: string | null = null;

    showEditNamePopup: boolean = false;

    declare currency: any;

    private mounted() {
        if (!this.value.lines) {
            return;
        }

        this.value.lines.forEach((line) => {
            if (!line.lineId || line.lineId === '') {
                line.lineId = this.$helper.getGuid();
            }
        });
    }

    addRow(parentId: string | null) {
        this.parentRecordId = parentId;
        (this.$refs.treelist as any).instance!.addRow(parentId);
    }

    rowDeleted(e: any) {
        this.deleteWithParentId(e.data.lineId);
    }

    private deleteWithParentId(parentId: string) {
        if (!this.value.lines) {
            return;
        }

        const deletedIds: string[] = [];
        for (let i = this.value.lines!.length - 1; i >= 0; i--) {
            const line = this.value.lines[i];
            if (line.parentLineId === parentId) {
                deletedIds.push(line.lineId!);
                this.value.lines.splice(i, 1);
            }
        }

        deletedIds.forEach((id) => {
            this.deleteWithParentId(id);
        });
    }

    openAddArticle(parentId: string | null) {
        this.parentRecordId = parentId;
        (this.$refs.AddArticleDialog as AddArticleDialog).show = true;
    }

    addArticle(input: {
        article: IArticle,
        data: {
            articleId: string,
            quantity: number,
        },
    }) {
        // addArticleDialog
        const dialog = (this.$refs.AddArticleDialog as AddArticleDialog);
        try {
            dialog.updating = true;

            const articleVariant =
                input.article.variants && input.article.variants.length > 0 ? input.article.variants[0] : undefined;
            if (!articleVariant) { throw Error('Variant not found'); }
            const salesPrice = (articleVariant as IArticleVariant).salesPrices
                .find((o) => o.type === this.invoice.projectType);
            if (!salesPrice) { throw Error('Pricing not found'); }

            this.value.lines!.push(new InvoiceLine({
                lineId: this.$helper.getGuid(),
                parentLineId: this.parentRecordId === null ? undefined : this.parentRecordId,
                articleId: input.data.articleId,
                variant: input.article.variants && input.article.variants.length > 0 ? input.article.variants[0].name : '',
                measuringUnit: input.article.measuringUnit,
                quantity: input.data.quantity,
                price: salesPrice.price,
                originalPrice: salesPrice.price,
                cost: salesPrice.cost,
                discount: 0,
                description: `${input.article.name}: ${input.article.description}`,
                remarks: '',
                total: input.data.quantity * salesPrice.price,
                originalTotal: input.data.quantity * salesPrice.price,
                margin: input.data.quantity * (salesPrice.price - salesPrice.cost),
            }));

            dialog.show = false;
        } catch (err) {
            notificationService.showErrorMessage('Artikel kon niet toegevoegd worden');
        } finally {
            dialog.updating = false;
        }
    }

    rowInserting(e: any) {
        const data = e.data as IInvoiceLine;
        data.lineId = this.$helper.getGuid();
        this.value.lines!.unshift(new InvoiceLine(data));
        const instance = (this.$refs.treelist as any).instance;
        if (instance) {
            instance.cancelEditData();
        }

        e.cancel = true;
    }

    onReorderLine(e: any) {
        const visibleRows = e.component.getVisibleRows();
        const sourceData = e.itemData;
        const targetData = visibleRows[e.toIndex].data;

        if(sourceData.lineId == targetData.parentLineId){
            // User tried to drag a parent line in one of its child lines.
            // Not allowed
            return;
        }

        if (e.dropInsideItem) {
            e.itemData.parentLineId = targetData.lineId;
            e.component.refresh();
        } else {
            const sourceIndex = this.value.lines!.indexOf(sourceData);
            let targetIndex = this.value.lines!.indexOf(targetData);

            if (sourceData.parentLineId !== targetData.parentLineId) {
                sourceData.parentLineId = targetData.parentLineId;
                if (e.toIndex > e.fromIndex) {
                    targetIndex++;
                }
            }

            this.value.lines!.splice(sourceIndex, 1);
            this.value.lines!.splice(targetIndex, 0, sourceData);
        }
    }

    remove() {
        this.$emit('remove');
    }

    saveName() {
        this.showEditNamePopup = false;
    }

    private updateNotes(e: any) {
        const promptValue = prompt('Opmerking', e.row.data.remarks);
        if (promptValue) {
            e.row.data.remarks = promptValue;
        }
    }

    setTextColor(e: any) {
        // price
        if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 2) {
            if (e.data.price < e.data.originalPrice) {
                $(e.cellElement).addClass('text-danger');
            }
            if (e.data.price > e.data.originalPrice) {
                $(e.cellElement).addClass('text-success');
            }
        }
        // margin
        if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 4) {
            if (e.data.price < e.data.cost) {
                $(e.cellElement).addClass('text-danger');
            }
            if (e.data.price > e.data.cost) {
                $(e.cellElement).addClass('text-success');
            }
        }
        // Total margin
        if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 5) {
            if (e.data.price < e.data.cost) {
                $(e.cellElement).addClass('text-danger');
            }
            if (e.data.price > e.data.cost) {
                $(e.cellElement).addClass('text-success');
            }
        }
    }

    get total() {
        let res = 0;
        if (!this.value.lines || this.value.lines.length <= 0) {
            return res;
        }

        this.value.lines.forEach((line: any) => {
            if (line.quantity && line.price) {
                res += line.quantity * line.price;
            }
        });

        return res;
    }

    get totalOriginal() {
        let res = 0;
        if (!this.value.lines || this.value.lines.length <= 0) {
            return res;
        }

        this.value.lines.forEach((line: any) => {
            if (line.quantity && line.originalPrice) {
                res += line.quantity * line.originalPrice;
            }
        });

        return res;
    }

    get margin() {
        let res = 0;
        if (!this.value.lines || this.value.lines.length <= 0) {
           return res;
        }

        this.value.lines.forEach((line: any) => {
           const cost = line.cost ? line.cost : 0; // get cost

           // Calculate margin
           if (line.quantity && line.price) {
               res += line.quantity * (line.price - cost);
           }
        });

        return res;
    }

    get measuringUnits() {
        const measuringUnits = this.$store.getters['measuringUnits/data'];

        return measuringUnits ?? [];
    }

    get columns() {
        const self = this;
        return [
            {
                dataField: 'description',
                caption: 'Beschrijving',
            },
            {
                dataField: 'quantity',
                caption: 'Hoeveelheid',
                alignment: 'left',
                dataType: 'number',
                calculateCellValue(value: any) {
                    if (value.quantity) {
                        return Math.round(value.quantity * 1000) / 1000;
                    }
                    return 0;
                },
            },
            {
                dataField: 'measuringUnit',
                caption: 'Meeteenh.',
                lookup: {
                    dataSource: self.measuringUnits,
                },
            },
            {
                dataField: 'price',
                caption: 'Prijs',
                dataType: 'number',
                alignment: 'left',
                format: CURRENCY_FORMAT,
            },
            {
                dataField: 'cost',
                caption: 'Kost',
                dataType: 'number',
                alignment: 'left',
                format: CURRENCY_FORMAT,
            },
            {
                alignment: 'left',
                caption: 'Orginele prijs',
                cssClass: '',
                format: CURRENCY_FORMAT,
                calculateCellValue(value: any) {
                    if (value.originalPrice) {
                        return value.originalPrice;
                    }
                    return 0;
                },
            },
            {
                alignment: 'left',
                formItem: {
                    visible: false,
                },
                caption: 'Marge',
                cssClass: '',
                format: CURRENCY_FORMAT,
                calculateCellValue(value: any) {
                    if (value.cost && value.price) {
                        return value.price - value.cost;
                    }
                    if (value.price) {
                        return value.price;
                    }
                    return 0;
                },
            },
            {
                alignment: 'left',
                formItem: {
                    visible: false,
                },
                caption: 'Marge',
                cssClass: '',
                format: CURRENCY_FORMAT,
                calculateCellValue(value: any) {
                    if (value.cost && value.price && value.quantity) {
                        return (value.price - value.cost) * value.quantity;
                    }

                    if (value.price && value.quantity) {
                        return value.price * value.quantity;
                    }

                    return 0;
                },
            },
            {
                alignment: 'left',
                formItem: {
                    visible: false,
                },
                caption: 'Totaal',
                cssClass: '',
                format: CURRENCY_FORMAT,
                calculateCellValue(value: any) {
                    if (value.quantity && value.price) {
                        return value.quantity * value.price;
                    }
                    return 0;
                },
            },
            {
                dataField: 'remarks',
                caption: 'Opmerkingen',
                dataType: 'text',
                visible: false,
            },
            {
                type: 'buttons',
                buttons: [
                {
                    hint: 'Opmerking',
                    icon: 'fas fa-comment-dots',
                    visible(e: any) {
                        return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled;
                    },
                    onClick: this.updateNotes,
                },
                {
                    hint: 'Code invoegen',
                    icon: 'fas fa-search-plus',
                    visible(e: any) {
                        return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled;
                    },
                    onClick: (e: any) => {
                        this.openAddArticle(e.row.data.lineId);
                    },
                },
                {
                    hint: 'Verbergen',
                    icon: 'fas fa-eye',
                    visible(e: any) {
                        return !e.row.isEditing && !e.row.data.hidden && !self.disabled;
                    },
                    onClick: (e: any) => {
                        self.value.lines!.find((line) => line.lineId === e.row.data.lineId)!.hidden = true;
                        (this.$refs.treelist as any).instance.repaint();
                    },
                },
                {
                    hint: 'Tonen',
                    icon: 'fas fa-eye-slash',
                    visible(e: any) {
                        return !e.row.isEditing && e.row.data.hidden && !self.disabled;
                    },
                    onClick: (e: any) => {
                        self.value.lines!.find((line) => line.lineId === e.row.data.lineId)!.hidden = false;
                        (this.$refs.treelist as any).instance.repaint();
                    },
                },
                'edit',
                'delete'],
            },
        ];
    }

    get cardDisabled() {
        return this.disabled || this.editDisabled;
    }
}
